import * as React from "react";
import { RecommendationsProps } from "./components/Recommendations";
import { RecommendationProps } from "./components/Recommendation";
import { Context } from "./context";
import Cards from "./components/Cards";
import { detect, BrowserInfo } from "detect-browser";
import Recommendations from "./components/Recommendations";

export interface AppData {
	questionSliderData?: RecommendationProps;
	tbsSliderData?: RecommendationProps;
}

export interface AppProps {
	context?: Context;
	theme?: string;
	groupName?: string;
	groupId?: number;
	initialState?: AppState;
}

export enum RecommendationKind {
	TBS = "TBS",
	QnA = "QnA",
}

interface AppState {
	loaded: string;
}

class App extends React.Component<AppProps, AppState> {
	static displayName = "App";
	browser: BrowserInfo;

	constructor(props: AppProps) {
		super(props);
		this.browser = detect() as BrowserInfo;
		this.state = this.props.initialState || {
			loaded: "",
		};
	}

	firstLoadCompleted() {
		if (this.state.loaded !== "loaded") {
			this.setState({
				loaded: "loaded",
			});
		}
	}

	render() {
		const { props } = this;
		const hasTheme = props.theme === "colored";

		if (props.context === "QnA" && !(props.groupId && props.groupName)) {
			throw "GroupID and GroupName are required while rendering QnA Recommendations";
		}

		if (
			props.context !== "CSHP" &&
			props.context !== "QnA" &&
			props.context !== "myQnA" &&
			props.context !== "myTBS"
		) {
			return null;
		}

		const recommendationsProps: RecommendationsProps = {
			theme: hasTheme,
			firstLoadCompleted: () => this.firstLoadCompleted(),
			context: props.context,
		};

		return (
			<div className={`browser-${this.browser.name}`} data-app={true}>
				{props.context !== "QnA" ? (
					<div className={`animate-in ${this.state.loaded}`}>
						<Recommendations {...recommendationsProps} />
					</div>
				) : (
					<Cards groupName={props.groupName} groupId={props.groupId} />
				)}
			</div>
		);
	}
}

export default App;
